
// THIS MODEL IS NOT CRECT AND NEEDS UPDATING (think I updated it and works.)

// tslint:disable-next-line:quotemark
import { StringLiteralLike } from "typescript";
import {Deserializable} from "./deserializable.model";

export class AppRoute {

public app_route_id?: number;
public app_route_parent_id?: number; // so we can have sub route system
public app_route_name?: string;
public app_guard?: string;
public app_route_notes?: any;
public app_route_description?: string;
public app_route_type_id?: any; // This will eventually determin where and create rules on when used and displayed. (main,has vars)
public app_route_insert_type_id?: any; // This will eventually determin where and create rules on when used and displayed.

public app_route_as_actual?: any;
public app_route_as_actual_NAME?: any;
public app_route_as_variable?: any;
public app_route_as_variable_NAME?: string;


public app_route_HTML_FILE?: any;

public app_route_1?: any;
public app_route_2?: any;
public app_route_3?: any;
public app_route_4?: any;
public app_route_5?: any;


// Not yet used or created in data or structure.
public subject_com_type_id?: number;
public brand_type_id?: any;

public is_active?: any;
// if is of type affidavit court documents.
// new logic to handle all document and correspondece creation in system
public job_type_affidavit_type_id?: any;
public job_type_court_id?: any;
public job_type_location_id?: any;
public job_type_id?: any;
public job_type_document_type_id?: any;

public brand_id?: number;
public user_id?: any;
public user_level_id?: any;
public keywords?: any;
public routerLink?: string;
public routerLinkGeneral?: string; // without the ID so I can show "General" help items in sector.

public app_route_database_table?: string;
public app_route_database?: string;
public app_route_database_model?: string;
public app_route_database_server?: string;


// seach system    
created_date_from?;
created_date_to?;

public log_type_data_sector_id?: number;
public log_type_data_sector_array?: number;
public log_type_data_sector_name?: any;

public help_content?: any;
public help_content_HTML?: any;
public video_content?: any;
public video_content_array?: any;
public guided_tour_content?: any;


public app_route_colour?: string;
public app_route_icon?: string;
public app_route_icon_file?: any;
public app_route_background_file?: any;
public app_route_seo_meta?: any;
public created_tested?: string;
public notes?: string;
public updated_date?: string;
public updated_by?: number;
public created_date?: string;
public created_by?: number;
public file_number?: number;

public app_route_has_children_count?: number // retuns a count if true... and number of.
app_id?;
project_id?;
condition_array?;

app_route_total?;
app_route_subtotal?;
app_route_gst?;
app_route_time_estimate?; // hours

project_route_order? // order of routes on project and output of documents


app_route_number?
app_route_child_number?
app_route_parent_array?
app_route_related_array?
app_route_dependant_array?


file_number_selector?
app_route_number_selector?
app_route_child_number_selector?
app_route_type_id2? // allows for multiple types to be selected with or...
limit?
routerLinkEquals? // set this to get the base_route by routerLink -- search matrix
app_route_insert_type_id_NOT? // set so that I can dispaly all items route items not done.
}

// 
